import { FeedbotThunk } from '../../../store/types'
import { AuthorId, Comment, CommentId, CommentsPatch } from '../types'
import { updateCommentOnServer } from './updateCommentOnServer'
import { authorForCurrentUserSelector } from '../../../store/user'
import { Dictionary, UserProfile } from '@feedyou/schema'

export const resolveCommentOnServer =
  (
    commentId: CommentId,
    localAuthors: Dictionary<AuthorId, UserProfile>,
    replyComments: Comment[] = []
  ): FeedbotThunk =>
  (dispatch, getState) => {
    const author = authorForCurrentUserSelector(getState())
    if (!author?.id) return

    const patchForReplyComment: Partial<Comment> = {
      status: 'resolved'
    }

    const patchForParentComment: Partial<Comment> = {
      ...patchForReplyComment,
      resolved: { byAuthorId: author.id, timestamp: Date.now() }
    }

    const commentsPatch = {
      [commentId]: patchForParentComment,
      ...replyComments.reduce((output, replyComment) => {
        output[replyComment.id] = patchForReplyComment
        return output
      }, {} as CommentsPatch)
    }

    return dispatch(updateCommentOnServer(commentId, commentsPatch, localAuthors))
  }
